import { Component, computed, inject, signal } from '@angular/core';
import { NzInputModule } from 'ng-zorro-antd/input';
import { PageLogoHeaderComponent } from '../../../share/page-logo-header/page-logo-header.component';
import { ButtonComponent } from '../../../share/ava-button/ava-button.component';
import { clubOption } from '../../../../signals';
import { TesterGateService } from './tester-gate.service';

@Component({
  selector: 'ava-tester-gate',
  standalone: true,
  template: `
    <ava-page-header />

    <div class="tw-mx-auto tw-flex tw-max-w-[640px] tw-flex-col tw-gap-4 tw-pb-8 tw-text-center">
      <h2 class="ava-header-bold">Pardon Our Dust!</h2>
      <p class="ava-text">
        We're making improvements to better serve you! Our online join and renew functions are currently unavailable.
      </p>
      <p class="ava-text">
        Need Roadside Assistance? We've got you covered! Call
        <a class="tw-text-link tw-underline hover:tw-no-underline" href="tel:18002224357">
          1-800-AAA-HELP (1-800-222-4357)
        </a>
        or use the AAA Mobile App to request service anytime.
      </p>
      <p class="ava-text">
        Need something else? Leave us a message at
        <a class="tw-text-link tw-underline hover:tw-no-underline" [href]="'tel:' + clubOption().phoneNumber">
          {{ clubOption().phoneNumberView }}</a
        >, or call us when we reopen.
      </p>
      <p class="ava-text">Thanks for your patience as we work to improve your experience - we appreciate you!</p>
      <p class="ava-text">
        We are making improvements to our systems, and during this time you will not be able to join or renew your
        membership. We apologize for any inconvenience and appreciate your patience and understanding as we work to
        complete these changes.
      </p>

      <details class="tw-mt-6 tw-self-center">
        <summary class="ava-text-sm tw-cursor-pointer tw-text-gray-dark">Tester access</summary>
        <div class="tw-mt-2 tw-flex tw-items-center tw-gap-2">
          <input
            #code
            nz-input
            aria-label="Tester code"
            autocomplete="off"
            placeholder="Code"
            (input)="invalid.set(false)"
            (keydown.enter)="enter(code.value)"
          />
          <ava-button label="Enter" (clicked)="enter(code.value)" />
        </div>
        @if (invalid()) {
          <p class="ava-text-sm tw-mt-1 tw-text-red">That code didn't work.</p>
        }
      </details>
    </div>
  `,
  imports: [NzInputModule, PageLogoHeaderComponent, ButtonComponent],
})
export class TesterGate {
  private testerGate = inject(TesterGateService);

  clubOption = computed(() => clubOption());
  invalid = signal(false);

  enter(code: string) {
    this.invalid.set(!this.testerGate.enter(code));
  }
}
